const AU_POSTCODE_RANGES = [
  { min: 200, max: 299, state: "ACT" },
  { min: 800, max: 999, state: "NT" },
  { min: 1000, max: 2599, state: "NSW" },
  { min: 2600, max: 2618, state: "ACT" },
  { min: 2619, max: 2899, state: "NSW" },
  { min: 2900, max: 2920, state: "ACT" },
  { min: 2921, max: 2999, state: "NSW" },
  { min: 3000, max: 3999, state: "VIC" },
  { min: 4000, max: 4999, state: "QLD" },
  { min: 5000, max: 5999, state: "SA" },
  { min: 6000, max: 6999, state: "WA" },
  { min: 7000, max: 7999, state: "TAS" },
  { min: 8000, max: 8999, state: "VIC" },
  { min: 9000, max: 9999, state: "QLD" },
];

function lookupAustralianPostcode(postcode) {
  const digits = String(postcode).replace(/\D/g, "").slice(0, 4);
  if (digits.length < 3) return null;

  const pc = parseInt(digits, 10);
  if (Number.isNaN(pc)) return null;

  const range = AU_POSTCODE_RANGES.find((item) => pc >= item.min && pc <= item.max);
  if (!range) return null;

  return {
    postcode: digits.padStart(4, "0").slice(0, 4),
    state: range.state,
  };
}

function lookupPostcode(postcode) {
  if (window.FotilePostcodes?.lookupPostcode) {
    const result = window.FotilePostcodes.lookupPostcode(postcode);
    if (result) return result;
  }
  return lookupAustralianPostcode(postcode);
}

function createXMultipleStores(sectionId) {
  let config = {
    stores: [],
    enableLocator: false,
    shopOnlineUrl: "/collections/all",
    shopOnlineLabel: "Shop Online",
    emailSignupLabel: "Subscribe to our email",
    noStoreHeading: "No store in your state",
    noStoreMessage: "We don't have a store in [state] yet. Shop online or subscribe for updates.",
    invalidPostcodeMessage: "Please enter a valid Australian postcode.",
    postcodeNotFoundMessage: "Postcode not found. Try another postcode.",
    resultsMessage: "Showing [count] store(s) in [state] near [postcode].",
    locatorPlaceholder: "Enter your postcode",
    locatorButtonLabel: "Find stores",
    showAllStoresLabel: "Show all stores",
  };

  try {
    const dataEl = document.getElementById(`multiple-stores-data-${sectionId}`);
    if (dataEl) {
      config = { ...config, ...JSON.parse(dataEl.textContent) };
    }
  } catch (e) {}

  return {
    active: 1,
    open: false,
    canScroll: false,
    atTop: true,
    atBottom: false,
    showStore: false,
    stores: config.stores,
    enableLocator: config.enableLocator,
    shopOnlineUrl: config.shopOnlineUrl,
    shopOnlineLabel: config.shopOnlineLabel,
    emailSignupLabel: config.emailSignupLabel,
    noStoreHeading: config.noStoreHeading,
    noStoreMessage: config.noStoreMessage,
    invalidPostcodeMessage: config.invalidPostcodeMessage,
    postcodeNotFoundMessage: config.postcodeNotFoundMessage,
    resultsMessage: config.resultsMessage,
    locatorPlaceholder: config.locatorPlaceholder,
    locatorButtonLabel: config.locatorButtonLabel,
    showAllStoresLabel: config.showAllStoresLabel,
    postcodeInput: "",
    locatorSearched: false,
    locatorState: "",
    locatorPostcode: "",
    noStoresInState: false,
    visibleStoreIndexes: null,
    locatorMessage: "",
    locatorSuggestions: [],
    showLocatorSuggestions: false,
    mapEmbedUrl(heading, address) {
      const query = [heading, address].filter(Boolean).join(", ");
      if (!query) return "";
      return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
    },
    loadStoreMap(container) {
      if (!container) return;
      const iframe = container.querySelector("iframe");
      if (!iframe) return;

      // Theme setting overwrite: use pasted iframe src when present
      const embedSrc = (container.dataset.mapEmbed || "").trim();
      if (embedSrc) {
        iframe.src = embedSrc;
        return;
      }

      const heading = container.dataset.mapHeading || "";
      const address = container.dataset.mapAddress || "";
      if (!heading && !address) return;
      iframe.src = this.mapEmbedUrl(heading, address);
    },
    clearStoreMap(container) {
      if (!container) return;
      const iframe = container.querySelector("iframe");
      if (iframe) iframe.src = "";
    },
    loadActiveStoreMap() {
      if (!this.$refs.h_img_location) return;
      this.$refs.h_img_location.querySelectorAll("[data-store-map]").forEach((panel) => {
        this.clearStoreMap(panel);
      });
      this.loadStoreMap(this.$refs.h_img_location.querySelector(`[data-store-index="${this.active}"]`));
    },
    fillLocatorMessage(template, values) {
      return String(template)
        .replace(/\[count\]|\{\{\s*count\s*\}\}/g, values.count)
        .replace(/\[state\]|\{\{\s*state\s*\}\}/g, values.state)
        .replace(/\[postcode\]|\{\{\s*postcode\s*\}\}/g, values.postcode);
    },
    extractPostcodeFromAddress(address) {
      const matches = String(address || "").match(/\b(\d{4})\b/g);
      if (!matches?.length) return "";
      return matches[matches.length - 1];
    },
    resolveStoreFromAddress(address) {
      const postcode = this.extractPostcodeFromAddress(address);
      let state = "";

      if (postcode) {
        const location = lookupPostcode(postcode);
        if (location?.state) state = location.state;
      }

      if (!state) {
        const match = String(address || "").match(/\b(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\b/i);
        if (match) state = match[1].toUpperCase();
      }

      return { postcode, state };
    },
    postcodeDistance(userPc, storePc) {
      const user = parseInt(userPc, 10);
      const store = parseInt(String(storePc || "").replace(/\D/g, ""), 10);
      if (!storePc || Number.isNaN(store)) return Number.MAX_SAFE_INTEGER;
      return Math.abs(user - store);
    },
    isStoreVisible(index) {
      if (!this.enableLocator || !this.locatorSearched) return true;
      if (this.noStoresInState) return false;
      return this.visibleStoreIndexes.includes(index);
    },
    onPostcodeInput() {
      const raw = this.postcodeInput.trim();
      if (!raw) {
        this.locatorSuggestions = [];
        this.showLocatorSuggestions = false;
        return;
      }

      if (window.FotilePostcodes?.searchPostcodes) {
        this.locatorSuggestions = window.FotilePostcodes.searchPostcodes(raw, 8);
      } else {
        const digits = raw.replace(/\D/g, "").slice(0, 4);
        const location = lookupAustralianPostcode(digits);
        this.locatorSuggestions = location
          ? [{ postcode: digits, state: location.state, city: "" }]
          : [];
      }

      this.showLocatorSuggestions =
        this.locatorSuggestions.length > 0 && raw.length > 0;
    },
    hideLocatorSuggestions() {
      requestAnimationFrame(() => {
        this.showLocatorSuggestions = false;
      });
    },
    selectLocatorSuggestion(item) {
      this.postcodeInput = item.city
        ? `${item.city}, ${item.state} ${item.postcode}`
        : String(item.postcode);
      this.showLocatorSuggestions = false;
      this.searchByPostcode();
    },
    searchByPostcode() {
      this.locatorMessage = "";
      const raw = this.postcodeInput.trim();
      const pcMatch = raw.match(/(\d{4})/);

      if (!pcMatch) {
        this.locatorMessage = this.invalidPostcodeMessage;
        return;
      }

      const postcode = pcMatch[1];
      const location = lookupPostcode(postcode);

      if (!location) {
        this.locatorSearched = true;
        this.noStoresInState = true;
        this.visibleStoreIndexes = [];
        this.locatorMessage = this.postcodeNotFoundMessage;
        return;
      }

      this.locatorState = location.state;
      this.locatorPostcode = postcode;
      this.locatorSearched = true;
      this.showLocatorSuggestions = false;

      const inState = this.stores
        .map((store) => {
          const resolved = this.resolveStoreFromAddress(store.address);
          return {
            ...store,
            resolvedPostcode: resolved.postcode,
            resolvedState: resolved.state,
          };
        })
        .filter((store) => store.resolvedState === location.state);

      if (inState.length === 0) {
        this.noStoresInState = true;
        this.visibleStoreIndexes = [];
        this.locatorMessage = this.fillLocatorMessage(this.noStoreMessage, {
          state: location.state,
        });
        return;
      }

      this.noStoresInState = false;
      this.visibleStoreIndexes = inState
        .sort(
          (a, b) =>
            this.postcodeDistance(postcode, a.resolvedPostcode) -
            this.postcodeDistance(postcode, b.resolvedPostcode)
        )
        .map((store) => store.index);

      this.active = this.visibleStoreIndexes[0];
      this.locatorMessage = this.fillLocatorMessage(this.resultsMessage, {
        count: this.visibleStoreIndexes.length,
        state: location.state,
        postcode,
      });

      requestAnimationFrame(() => this.loadActiveStoreMap());
    },
    resetLocator() {
      this.locatorSearched = false;
      this.noStoresInState = false;
      this.visibleStoreIndexes = null;
      this.locatorMessage = "";
      this.postcodeInput = "";
      this.locatorSuggestions = [];
      this.showLocatorSuggestions = false;
      this.active = 1;
      requestAnimationFrame(() => this.loadActiveStoreMap());
    },
    load() {
      const canScrollVertically =
        this.$refs.list_stores.scrollHeight >
        this.$refs.list_stores.closest(".multi_stores_content").clientHeight;
      if (canScrollVertically) {
        this.canScroll = true;
      }
      window.addEventListener("resize", () => {
        this.heightNatural();
      });
      this.heightNatural();
      if (!this._mapWatcher) {
        this._mapWatcher = true;
        this.$watch("active", () => {
          requestAnimationFrame(() => this.loadActiveStoreMap());
        });
      }
      this.loadActiveStoreMap();
    },
    heightNatural() {
      if (window.matchMedia("(min-width: 768px)").matches) {
        if (this.$refs.natural_height) {
          this.$refs.natural_height.style.height = this.$refs.h_img_location.offsetHeight + "px";
        }
      } else if (this.$refs.natural_height) {
        this.$refs.natural_height.style.removeProperty("height");
      }
    },
    openLocation(el) {
      this.open = true;
      var popupContent = document.getElementById(el.getAttribute("data-id"));

      this.$refs.content_location_detail.innerHTML = popupContent.innerHTML;
      const title = this.$refs.content_location_detail.querySelector("h5.location-title");
      if (title) {
        const h4 = document.createElement("h4");

        h4.innerHTML = title.innerHTML;
        h4.className = title.className;

        title.replaceWith(h4);
      }
      requestAnimationFrame(() => {
        this.loadStoreMap(this.$refs.content_location_detail.querySelector("[data-store-map]"));
      });
    },
    hideLocation() {
      this.open = false;
      Alpine.store("xPopup").open = false;
      if (Alpine.store("xModal")?.focused) {
        Alpine.store("xModal").removeFocus();
      }
      const detailEl = this.$refs.content_location_detail;
      if (detailEl) {
        this.clearStoreMap(detailEl.querySelector("[data-store-map]"));
      }
    },
    scrollUp() {
      this.$refs.list_stores.scrollBy({
        top: -200,
        behavior: "auto",
      });
      this.checkCanScrollVertical();
    },
    scrollDown() {
      this.$refs.list_stores.scrollBy({
        top: 200,
        behavior: "auto",
      });
      this.checkCanScrollVertical();
    },
    checkCanScrollVertical() {
      if (window.innerWidth < 768) {
        this.atTop = this.$refs.list_stores.scrollTop === 0;
        this.atBottom =
          this.$refs.list_stores.scrollTop +
            this.$refs.list_stores.closest(".multi_stores_content").clientHeight >=
          this.$refs.list_stores.scrollHeight - 2;
      }
    },
    toggleStore(noScroll = false) {
      this.showStore = !this.showStore;
      if (!this.showStore) {
        this.$refs.first_store.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (!noScroll) {
        this.canScroll = !this.canScroll;
        this.$refs.list_stores.addEventListener("animationend", this.checkCanScrollVertical());
        setTimeout(() => {
          this.$refs.list_stores.removeEventListener("animationend", this.checkCanScrollVertical());
        }, 300);
      }
    },
  };
}

window.Eurus = window.Eurus || {};
window.Eurus.createXMultipleStores = createXMultipleStores;

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xMultipleStores", (sectionId) => createXMultipleStores(sectionId));
  });
});
